import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '../components/Typography';

function Copyright() {
  return (
      <Grid container alignItems="center" spacing={0}>
        <Grid item xs={2}>
          <img
              src="/wrench.png"
              alt="ems logo"
              width="25"
              height="25"
          />
        </Grid>
        <Grid item xs={10}>
          <Typography
              component="footer"
              variant="caption"
              color={'primary.light'}
              sx={{ display: 'flex', py:0 }}
          >
            {'© Exeter Machine Shop.'}{' '}{new Date().getFullYear()}
          </Typography>
          <Typography
              component="footer"
              variant="caption"
              color={'primary.light'}
              sx={{ display: 'flex', py:0 }}
          >
            {' '}{'Exeter, New Hampshire, USA'}
          </Typography>
        </Grid>


      </Grid>

  );
}

export default function AppFooter() {
  return (
    <Typography
      component="footer"
      sx={{ display: 'flex', bgcolor: 'primary.dark' }}
    >
      <Container sx={{ mt:4, mb: 2, display: 'flex' }}>
        <Grid container spacing={2}>
          <Grid item xs={6} sm={4} md={3}>
            <Copyright />
          </Grid>
          <Grid item xs={6} sm={8} md={4}></Grid>
            <Grid item>
            </Grid>
        </Grid>
      </Container>
    </Typography>
  );
}
